// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__GtFPV","text":"Loading_text__HF6Ad"};